import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Chip,
  CircularProgress
} from "@mui/material";
import { auth, db } from "../../firebase";
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  orderBy,
  query,
  where, updateDoc
} from "firebase/firestore";
import Menu from "../../panel/Menu";

// --------------------------------------------------

function Roomcleanings() {
  const [propertyId, setPropertyId] = useState(null);
  const [roomsMap, setRoomsMap] = useState({});
  const [cleanRooms, setCleanRooms] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);

  // ---------------------------------------------
  // 1️⃣ FETCH PROPERTY ID FROM AUTHROLES
  // ---------------------------------------------
  useEffect(() => {
    return auth.onAuthStateChanged(async (user) => {
      if (!user) return;

      const snap = await getDoc(doc(db, "authroles", user.uid));
      if (snap.exists()) {
        setPropertyId(snap.data().propertyId);
      }
    });
  }, []);

  // ---------------------------------------------
  // 2️⃣ FETCH ROOMINFOS BY PROPERTY ID
  // ---------------------------------------------
  useEffect(() => {
    if (!propertyId) return;

    const q = query(
      collection(db, "roominfos"),
      where("propertyId", "==", propertyId)
    );

    return onSnapshot(q, (snap) => {
      const map = {};
      snap.docs.forEach((d) => {
        map[d.id] = d.data();
      });
      setRoomsMap(map);
    });
  }, [propertyId]);

  // ---------------------------------------------
  // 3️⃣ FETCH CLEANING ROOMS
  // ---------------------------------------------
  useEffect(() => {
    if (!propertyId) return;

    const q = query(
      collection(db, "cleaningrooms"),
      where("status", "==", "Cleaning"),
      orderBy("createdAt", "desc")
    );

    return onSnapshot(q, (snap) => {
      setCleanRooms(
        snap.docs.map((d) => ({
          id: d.id,
          ...d.data()
        }))
      );
      setLoading(false);
    });
  }, [propertyId]);

  // ---------------------------------------------
  // 4️⃣ JOIN & FILTER BY PROPERTY
  // ---------------------------------------------
  const filteredRooms = cleanRooms
    .filter((r) => roomsMap[r.roomid]) // only property rooms
    .filter((r) =>
      r.roomno.toLowerCase().includes(searchText.toLowerCase())
    );
  // ---------------------------------------------
  // UI
  // ---------------------------------------------

  // ---------------------------------------------
  // UPDATE ROOM STATUS TO CLEANED
  // ---------------------------------------------
  // ---------------------------------------------
  // UPDATE CLEANINGROOM + ROOMINFO STATUS
  // ---------------------------------------------
  // ---------------------------------------------
  // UPDATE CLEANINGROOM + ROOMINFO STATUS
  // ---------------------------------------------
  const markAsCleaned = async (cleaningRoom) => {
    try {
      const user = auth.currentUser;

      await updateDoc(doc(db, "cleaningrooms", cleaningRoom.id), {
        status: "Cleaned",
        cleanedby: user?.email || user?.uid || "",
        cleanedtime: new Date().toLocaleString()
      });

      await updateDoc(doc(db, "roominfos", cleaningRoom.roomid), {
        status: "Available"
      });

    } catch (error) {
      console.error("Error updating room status:", error);
    }
  };



  return (
    <>
      <Menu />

      <Box
        sx={{
          ml: "260px",
          p: 3,
          minHeight: "100vh",
          backgroundColor: "#f4f6f8"
        }}
      >
        <Typography variant="h5" fontWeight={600} gutterBottom>
          🧹 Cleaning Rooms
        </Typography>

        <Card elevation={4}>
          <CardContent>
            <TextField
              size="small"
              placeholder="Search Room No"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              sx={{ mb: 2, width: 250 }}
            />

            {loading ? (
              <Box textAlign="center" py={4}>
                <CircularProgress />
              </Box>
            ) : (
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f1f1f1" }}>
                    <TableCell><b>#</b></TableCell>
                    <TableCell><b>Room No</b></TableCell>
                    <TableCell><b>Room Type</b></TableCell>
                    <TableCell><b>Status</b></TableCell>
                    <TableCell><b>Action</b></TableCell>
                  </TableRow>
                </TableHead>


                <TableBody>
                  {filteredRooms.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No rooms found
                      </TableCell>
                    </TableRow>
                  )}

                  {filteredRooms.map((room, index) => {
                    const roomInfo = roomsMap[room.roomid];

                    return (
                      <TableRow key={room.id} hover>
                        <TableCell>{index + 1}</TableCell>

                        <TableCell>
                          <Typography fontWeight={600}>
                            {room.roomno}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          {roomInfo?.roomTypeName || "-"}
                        </TableCell>

                        <TableCell>
                          <Chip
                            label="Cleaning"
                            color="warning"
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <Chip
                            label="Mark Cleaned"
                            color="success"
                            size="small"
                            clickable
                            onClick={() => markAsCleaned(room)}
                          />
                        </TableCell>

                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            )}
          </CardContent>
        </Card>
      </Box>
    </>
  );
}

export default Roomcleanings;
